import { createApp } from "vue";
import { createHead } from '@vueuse/head'
import App from "./App.vue";
import router from "./router";
import i18n from "./plugins/i18n";
import directive from "./directives";

import "@/styles/common.scss"
import "@/styles/element-ui/index.scss";

const app = createApp(App);
const head = createHead();

app.use(router);
app.use(directive);
app.use(i18n);
app.use(head);

router.isReady().then(() => app.mount('#app'));
